let colors = ["#F44336", "#2196F3", "#4CAF50", "#FF5722", "#673AB7", "#E91E63", "#3F51B5", "#795548", "#607D8B", "#D500F9"];
function color(index) {
    return colors[index % colors.length];
}

export { color };